module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    staticClass: "page_not_found"
  }, [_c('div', {
    staticClass: "page_not_found__content"
  }, [_c('h2', {
    staticClass: "page_not_found__title title"
  }, [_vm._v("404")]), _vm._v(" "), _c('h2', {
    staticClass: "page_not_found__title description"
  }, [_vm._v(_vm._s(_vm.$t('message.pageNotFound')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af7dc52e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 848
// module chunks = 1 3